@if (_active) {
  <kendo-window #mainWindow
    title="{{ _pageState == 2 || _pageState == 5 ? 'ADD NEW RECORD' : _pageState == 3 ? 'EDIT RECORD' : _pageState == 1 ? 'VIEW RECORD' : _pageState == 4 ? 'EDIT FIELDS MODE' : '' }}"
    (close)="_closeForm()"
    (stateChange)="_onStateChanges($event)"
    class="fullWidthFormForm"
    [class.editFieldsModeClass]="_pageState == 4"
    [class.disabledPopup]="_editFormActive || _orderingTabsForm || _deactivatedFieldsForm"
    (keydown.enter)="$event.preventDefault()">
    <form novalidate [formGroup]="_form" class="form_style">
      <div class="row special_row_margin">
        <div class="col-12 special_col_padding">
          <div class="margin-top-4 border_sections">
            <div class="row">
              <div class="col-12">
                <h2 class="formsTitle">
                  Department
                  @if (canAccess('departments', 'update') && _pageState == 1) {
                    <span (click)="_edit()"
                      [class.ViewModeVisibleElement]="_pageState == 1"
                      class="action-button action-button-viewMode">
                      <div class="action-button-icon">
                        <img src="/assets/menu/enterprise/edit-action-icon-grid.svg" />
                      </div>
                      <div class="edit-icon-text">Edit</div>
                    </span>
                  }
                </h2>
                <div class="upsert-header-buttons">
                  <ul class="menuButtonsList">
                    <!-- *ngIf="_pageState == 2" -->
                    <!--  -->
                    @if (canAccess('departments', 'update')&& _pageState!=1) {
                      <li
                        (click)="_onEditForms()"
                        [class.ViewModelHiddenElement]="_pageState != 2 ">
                        Edit Forms
                      </li>
                    }
                    <li class="wikiButton"
                      (click)="_onEditFields()"
                      [class.ViewModeHiddenElement]="_pageState != 2">
                      Edit Fields
                    </li>
                    <li (click)="_returnAdNew()"
                      [class.ViewModeHiddenElement]="_pageState != 4">
                      Close Edit Fields
                    </li>
                    <!-- <li class="wikiButton">Wiki</li> -->
                    @if (_pageState == 2 && !_currentUser?.isEnterprise) {
                      <li
                        class="wikiButton"
                        [class.disabled]="_deactivatedFieldsGridData?.length == 0"
                        (click)="_viewInactiveFields();_deactivatedFieldsForm=true">
                        View Inactive Fields
                      </li>
                    }
                    @if (_pageState == 2) {
                      <li
                        class="wikiButton"
                        [class.disabled]="_deactivatedFormTabsGridData?.length == 0"
                        (click)="_viewInactiveFormTabs();_deactivatedFormTabsForm=true"
                        >
                        View Inactive Form Tabs
                      </li>
                    }
                  </ul>
                  @if (_pageState != 1) {
                    <div>
                      @if (canAccess('departments', 'create')) {
                        <button
                          kendoButton
                          class="steps_buttons_class"
                          (click)="_onCancel()">
                          <img class="backimage"
                            [src]="'/assets/menu/'+ _theme +'/close-schedule-report-icon-green.svg'" />
                            <span>close</span>
                          </button>
                        }
                        @if (canAccess('departments', 'create')) {
                          <button
                            kendoButton
                            class="steps_buttons_class"
                            [disabled]="_pageState == 4 ? true : false"
                            (click)="_onSave('saveAndCopy')">
                            <img class="backimage"
                              [src]="'/assets/menu/'+ _theme +'/save-icon-group.svg'" />
                              <span>save & Copy</span>
                            </button>
                          }
                          <button kendoButton
                            class="steps_buttons_class"
                            [disabled]="_pageState == 4 ? true : false"
                            (click)="_onSave('saveAndNew')">
                            <img class="backimage"
                              [src]="'/assets/menu/'+ _theme +'/save-icon-group.svg'" />
                              <span>save & New</span>
                            </button>
                            <button kendoButton
                              class="steps_buttons_class"
                              [disabled]="_pageState == 4 ? true : false"
                              (click)="_onSave('saveAndClose')">
                              <img class="backimage"
                                [src]="'/assets/menu/'+ _theme +'/save-icon-group.svg'" />
                                <span>save & Close</span>
                              </button>
                              <button kendoButton
                                class="steps_buttons_class"
                                [disabled]="_pageState == 4 ? true : false"
                                (click)="_onSave('save')">
                                <img class="backimage"
                                  [src]="'/assets/menu/'+ _theme +'/save-icon-group.svg'" />
                                  <span>save</span>
                                </button>
                              </div>
                            }
                          </div>
                        </div>
                      </div>
                      <div class="col-12 p-0">
                        <div class="formsMenuSeparator"></div>
                      </div>
                      <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 mt-4 mb-4">
                        <fieldset class="col-12"
                          [class.col-6-imp]="_pageState == 1 || _pageState == 2 || _pageState == 3 || _pageState == 4 || _pageState == 5">
                          <div KendoToolTip
                            class="form-group from_but_container special_style_formgroup margin-top-10">
                            <label for="code" class="control-label">   {{getLabel("LBL_DepartmentCode")?.currentText}}</label>
                            <!-- <input
                            #kendo_BarcodeGen_Department_Code
                            [class.ViewModeDisabledControl]="_pageState == 1"
                            type="text"
                            class="k-textbox writebox min-width-0 newFormControlWidth"
                            [placeholder]="'Code'"
                            [(ngModel)]="code"
                            [ngModelOptions]="{standalone: true}"
                            entityName="code"
                            required
                            /> -->
                            <input #kendo_BarcodeGen_Department_Code
                              [class.ViewModeDisabledControl]="_pageState == 1"
                              type="text"
                              class="k-textbox writebox min-width-0 newFormControlWidth"
                              [placeholder]="'Code'"
                              formControlName="code"
                              entityName="code"
                              [attr.disabled]="(_pageState == 2 || _pageState == 3 || _pageState == 5) ? null : 'disabled'"
                              [disabled]="(_pageState == 2 || _pageState == 3 || _pageState == 5) ? false : true"
                              required />
                              <a title="Generate Barcode"
                                class="cursor-pointer"
                                [class.ViewModeHiddenElement]="_pageState == 1 || _pageState == 4"
                                (click)="_generateBarcodeClick()">
                                <img class="searchIcon"
                                  [src]="'/assets/menu/'+ _theme +'/auto-generate-icon.svg'" />
                                </a>
                                <a title="Edit {{getLabel('LBL_DepartmentCode')?.currentText}}"
                                  [class.editfieldsIconvisible]="_pageState == 4"
                                  class="editFieldsIcon"
                                  (click)="_openRenameForm('LBL_DepartmentCode', true)">
                                  <img class="searchIcon"
                                    [src]="'/assets/menu/'+ _theme +'/edit-icon.svg'" />
                                  </a>
                                </div>
                                <div KendoToolTip class="form-group special_style_formgroup">
                                  <label for="description" class="control-label">  {{getLabel("LBL_DepartmentName")?.currentText}}</label>
                                  <!-- <input
                                  #kendo_Input_Dispose_Description
                                  [class.ViewModeDisabledControl]="_pageState == 1"
                                  type="text"
                                  class="k-textbox writebox newFormControlWidth"
                                  placeholder="Name"
                                  [(ngModel)]="name"
                                  [ngModelOptions]="{standalone: true}"
                                  [attr.required]="getLabel('LBL_DepartmentName')?.isRequired ? 'required' : null"
                                  /> -->
                                  <input #kendo_Input_Dispose_Description
                                    [class.ViewModeDisabledControl]="_pageState == 1"
                                    type="text"
                                    class="k-textbox writebox newFormControlWidth"
                                    placeholder="Name"
                                    formControlName="name"
                                    [attr.disabled]="(_pageState == 2 || _pageState == 3 || _pageState == 5) ? null : 'disabled'"
                                    [disabled]="(_pageState == 2 || _pageState == 3 || _pageState == 5) ? false : true"
                                    [attr.required]="getLabel('LBL_DepartmentName')?.isRequired ? 'required' : null" />
                                    <a title="Edit {{getLabel('LBL_DepartmentName')?.currentText}}"
                                      [class.editfieldsIconvisible]="_pageState == 4"
                                      class="editFieldsIcon"
                                      (click)="_openRenameForm('LBL_DepartmentName')">
                                      <img class="searchIcon"
                                        [src]="'/assets/menu/'+ _theme +'/edit-icon.svg'" />
                                      </a>
                                    </div>
                                  </fieldset>
                                </div>
                              </div>
                              <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 row m-0 p-0 mt-3">
                                <div class="col-xl-10 col-lg-9 col-md-12 col-sm-12 col-xs-12 responsive_style numericboxtab"
                                  #kendo_tabstrip_wrapper>
                                  <kendo-tabstrip #kendo_tabstrip
                                    class="full-height"
                                    [tabPosition]="_kendoTabStripPosition"
                                    (tabSelect)="_onTabSelect($event)">
                                    <!-- Accounts Tab -->
                                    @if (_currentUser && _currentUser.isEnterprise) {
                                      <kendo-tabstrip-tab
                                        #accountTab title="Accounts"
                                        [selected]="_currentUser && _currentUser.isEnterprise">
                                        <ng-template kendoTabContent>
                                          <div class="greytabtop menumobilecontainer">
                                            <img class="mobiletabIcon"
                                              (click)="_mobileMenuToggle()"
                                              [src]="'/assets/menu/'+ _theme +'/fields-menu-icon.svg'" />
                                            </div>
                                            <div class="tabcontent tabWizGridInside accountTab"
                                              [class.active]="_addClassActive">
                                              <asap-account-sites-selection
                                                [class.ViewModeDisabledControl]="_pageState == 1"
                                                [disabled]="_pageState == 1"
                                                [selectedAccounts]="_selectedAccounts"
                                                [enableSiteSelection]="false"
                                                [resolver]="_getAccounts"
                                                (onRowSelectionChanges)="_onAccountRowSelectionChanges($event)">
                                              </asap-account-sites-selection>
                                            </div>
                                          </ng-template>
                                        </kendo-tabstrip-tab>
                                      }
                                      @for (tab of _dataTabs; track tab; let i = $index) {
                                        @if (tab.isCustom) {
                                          <kendo-tabstrip-tab [title]="tab.name"
                                            [selected]="i == 0">
                                            <ng-template kendoTabContent>
                                              <div class="tabcontent">
                                                <fieldset class="contenttabstyle margin-top-10">
                                                  <asap-custom-fields-form [customFields]="_customFields[tab.id]"
                                                    [pageState]="_pageState"
                                                    [accounts]="_selectedAccountIds"
                                                    [formName]="_entity"
                                                    [page]="_page"
                                                    [invalidSubmit]="_invalidSubmit"
                                                    (customFieldsValue)="_customFieldsValueChanges($event, tab.id)"
                                                    (customFieldsDeleteValue)="_removeCustomField($event)"
                                                    (customFieldsEditValue)="_openCustomRenameForm($event, tab.id)"
                                                    (customFieldsStatus)="formStatus($event)"
                                                    [_customFieldsValue]="_customFieldsValue">
                                                  </asap-custom-fields-form>
                                                  <div class="form-group special_style_formgroup">
                                                    <button kendobutton
                                                      class="addNewFieldButton k-button"
                                                      (click)="_addNewField(tab.id)">
                                                      <img class="backimage"
                                                        src="/assets/menu/enterprise/add-icon-green.svg" /><span>Add New Field</span>
                                                      </button>
                                                    </div>
                                                    <div class="form-group special_style_formgroup">
                                                      <button kendobutton
                                                        class="addNewFieldButton k-button"
                                                        (click)="_deactivateTab(tab.id, _page)">
                                                        <img class="backimage"
                                                          src="/assets/menu/enterprise/add-icon-green.svg" /><span>Deactivate Tab</span>
                                                        </button>
                                                      </div>
                                                    </fieldset>
                                                  </div>
                                                </ng-template>
                                              </kendo-tabstrip-tab>
                                            }
                                          }
                                        </kendo-tabstrip>
                                        <div class="row no_row_margin">
                                          <div class="col-12">
                                            <button kendobutton
                                              class="addNewtabButton k-button"
                                              (click)="_addNewTab()">
                                              <img class="backimage"
                                                src="/assets/menu/enterprise/add-icon-green.svg" />
                                                <span>Add New Tab</span>
                                              </button>
                                            </div>
                                          </div>
                                          <div class="row no_row_margin">
                                            <div class="col-12">
                                              <button kendobutton
                                                class="reorderTabButton k-button"
                                                (click)="_reorderingtabs()">
                                                <img class="backimage"
                                                  src="/assets/menu/enterprise/reorder-tabs-icon.svg" />
                                                  <span>reorder tabs</span>
                                                </button>
                                              </div>
                                            </div>
                                          </div>
                                          <!-- <div class="col-xl-2 col-lg-3 col-md-12 col-sm-12 col-xs-12 p-0">
                                          <note #note [_pageState]="_pageState" [_model]="_model" [_page]="_page"></note>
                                        </div> -->
                                      </div>
                                    </div>
                                  </div>
                                  <div class="row">
                                    <div class="col-12">
                                      @if (_invalidForm) {
                                        <asap-forms-validation-summary
                                          [form]="_form"
                                          [page]="'departments'"
                                          [customValidation]="_customValidation"
                                          [additionalErrors]="_additionalErrors">
                                        </asap-forms-validation-summary>
                                      }
                                      <!-- <asap-forms-validation-summary
                                      *ngIf="_invalidSubmit"
                                      [form]="_form"
                                      [page]="'categories'"
                                      [isCustom]="true"
                                      [customValidation]="_customFieldsValue"
                                      [customFields]="_customFields"
                                      >
                                    </asap-forms-validation-summary> -->
                                  </div>
                                </div>
                              </form>
                              @if (_isDialiog) {
                                <asap-dialog-layout
                                  [data]="_dialogModel"
                                  [componentName]="_dialogComponentName">
                                </asap-dialog-layout>
                              }
                              <!-- <div
                              class="k-overlay"
    *ngIf=" _isDialiog || _deactivatedFormTabsForm ||_deactivatedFieldsForm
     || _isDialiog || _editFormActive ||  _orderingTabsForm ||
      _isEditForms "
                            ></div> -->
                            @if (_isEditForms || _deactivatedFormTabsForm) {
                              <div class="k-overlay"></div>
                            }
                          </kendo-window>
                        }

                        @if (_editFormActive) {
                          <kendo-window
                            title="{{ _isCustomfieldsFormValue ? 'Add Custom Fields' : (_isAddTabFormValue ? 'Add New Tabs' : (_isRenameFormValue ? 'Edit Record' : '')) }}"
                            (close)="_closeCustomFields()"
                            class="customFieldsWindow">
                            <asap-custom-fields [accounts]="_selectedAccountIds"
                              [tabGroup]="_selectedTabId"
                              [labelId]="_selectedLabelId"
                              [labelObjectCode]="_selectedLabelObjectCode"
                              [formName]="_entity"
                              [page]="_page"
                              [permissionScope]="_permissionScope"
                              [isCustomfieldsForm]="_isCustomfieldsFormValue"
                              [isCustomtabsForm]="_isAddTabFormValue"
                              [isRenameForm]="_isRenameFormValue"
                              [language]="_language"
                              [isRenameCustomForm]="_isRenameCustomFormValue"
                              [isRenameLabel]="_isRenameLabel"
                              [isMandatory]="_isMandatory"
                              (closePopup)="ClosePopup($event)">
                            </asap-custom-fields>
                          </kendo-window>
                        }

                        @if (_orderingTabsForm) {
                          <kendo-window
                            title="Tab Reordering"
                            (keydown.enter)="$event.preventDefault()"
                            (close)="_closeOrderingTabsForm()">
                            <div class="row no_row_margin py-2 margin-top-4 border_sections">
                              <div class="col-12">
                                <button kendoButton class="steps_buttons_class" (click)="_onSaveTabOrdering()">
                                  <img class="backimage" [src]="'/assets/menu/'+ _theme +'/save-icon-group.svg'" />
                                  <span>save & Close</span>
                                </button>
                              </div>
                            </div>
                            <div class="row no_row_margin p-3 margin-top-30">
                              @if (false) {
                                <div class="col-12 margin-top-10">
                                  <div class="form-group">
                                    <label for="itemType" class="control-label">Tab 1</label>
                                    <kendo-combobox [data]="_dataTabsSelected"
                                      [suggest]="true"
                                      [textField]="'name'"
                                      [valueField]="'name'"
                                      placeholder="Accounts/Sites"
                                      class="newFormControlWidth disabled">
                                    </kendo-combobox>
                                  </div>
                                </div>
                              }
                              @for (item of _dataTabs ; track item; let i = $index) {
                                <div class="col-12 margin-top-10">
                                  <div class="form-group">
                                    <label for="itemType" class="control-label">Tab {{ i + 1 }}</label>
                                    <kendo-combobox [data]="_dataTabsSelected"
                                      [suggest]="true"
                                      [textField]="'name'"
                                      [valueField]="'name'"
                                      [placeholder]="item.name"
                                      required
                                      class="bordered newFormControlWidth"
                                      (valueChange)="_comboValueChange($event,i)">
                                    </kendo-combobox>
                                  </div>
                                </div>
                              }
                            </div>
                          </kendo-window>
                        }

                        @if (_deactivatedFieldsForm) {
                          <kendo-window
                            title="Deactivated Fields"
                            (close)="_closeInactiveFields()">
                            <div class="row no_row_margin margin-top-30">
                              <div class="col-12 margin-top-10">
                                <kendo-grid [data]="_deactivatedFieldsGridData" [scrollable]="'none'">
                                  <kendo-grid-column field="name" title="Fields Name">
                                  </kendo-grid-column>
                                  <kendo-grid-column field="formTab.name" title="Tab Name">
                                  </kendo-grid-column>
                                  <kendo-grid-column field="createdOn" title="Added Date" type="date">
                                    <ng-template kendoGridCellTemplate let-dataItem>
                                      {{dataItem.createdOn | dateFormat}}
                                    </ng-template>
                                  </kendo-grid-column>
                                  <kendo-grid-column field="lastUpdatedOn"
                                    title="Deactivation Date"
                                    type="date">
                                    <ng-template kendoGridCellTemplate let-dataItem>
                                      {{dataItem.lastUpdatedOn | dateFormat}}
                                    </ng-template>
                                  </kendo-grid-column>
                                  <kendo-grid-column field="Command" title="Command">
                                    <ng-template kendoGridCellTemplate let-dataItem>
                                      <div class="action-button action-button-deactivate"
                                        (click)="_reactivate(dataItem)">
                                        <div class="action-button-icon">
                                          <img src="/assets/menu/enterprise/deactivate-icon.svg" />
                                        </div>
                                        <div class="edit-icon-text">Reactivate</div>
                                      </div>
                                    </ng-template>
                                  </kendo-grid-column>
                                </kendo-grid>
                              </div>
                            </div>
                          </kendo-window>
                        }
                        @if (_deactivatedFormTabsForm) {
                          <kendo-window
                            title="Deactivated Forms"
                            (close)="_closeInactiveFormTabs()"
                            style="z-index: 10050;">
                            <div class="row no_row_margin margin-top-30">
                              <div class="col-12 margin-top-10">
                                <kendo-grid [data]="_deactivatedFormTabsGridData" [scrollable]="'none'">
                                  <!-- <kendo-grid-column field="name" title="Fields Name">
                                </kendo-grid-column> -->
                                <kendo-grid-column field="name" title="Tab Name">
                                </kendo-grid-column>
                                <kendo-grid-column field="createdOn" title="Added Date" type="date">
                                  <ng-template kendoGridCellTemplate let-dataItem>
                                    {{dataItem.createdOn | dateFormat}}
                                  </ng-template>
                                </kendo-grid-column>
                                <kendo-grid-column field="lastUpdatedOn"
                                  title="Deactivation Date"
                                  type="date">
                                  <ng-template kendoGridCellTemplate let-dataItem>
                                    {{dataItem.lastUpdatedOn | dateFormat}}
                                  </ng-template>
                                </kendo-grid-column>
                                <kendo-grid-column field="Command" title="Command">
                                  <ng-template kendoGridCellTemplate let-dataItem>
                                    <div class="action-button action-button-deactivate"
                                      (click)="_reactivateFormTab(dataItem)">
                                      <div class="action-button-icon">
                                        <img src="/assets/menu/enterprise/deactivate-icon.svg" />
                                      </div>
                                      <div class="edit-icon-text">Reactivate</div>
                                    </div>
                                  </ng-template>
                                </kendo-grid-column>
                              </kendo-grid>
                            </div>
                          </div>
                        </kendo-window>
                      }
                      @if (_isEditForms) {
                        <asap-edit-forms
                          (close)="_onCloseEditForms($event)"
                          (saved)="_closeCustomFields()"
                          [page]="_page"
                        [permissionScope]="_permissionScope"></asap-edit-forms>
                      }
                      <!-- <asap-dialog-layout
                      *ngIf="_isDialiog"
                      [data]="_dialogModel"
                      [componentName]="_dialogComponentName"

                      >
                    </asap-dialog-layout> -->
                    @if ( _isDialiog || _deactivatedFormTabsForm ||_deactivatedFieldsForm
                      || _isDialiog || _editFormActive ||  _orderingTabsForm ||
                      _isEditForms ) {
                      <div class="k-overlay"
                      ></div>
                    }
